import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import LeadsContext from '../../../../../../providers/Leads';
import DealContext from '../../../../../../providers/Deal/Deal.context';
import { CollapsibleSection } from 'components/CollapsibleSection';
import DocumentsIcon from 'icons/Documents.icon';
import { useTranslation } from 'react-i18next';
import usePastTime from 'hooks/usePastTime';
import WarningExclamationIcon from 'icons/WarningExclamation.icon';
import ListOfNodes from './components/ListOfNodes';
import api from 'api';
import { Link } from 'react-router-dom';
import LinkToIcon from 'icons/LinkTo.icon';
import { getDataRoomRoute } from 'utils';
import { FIRST_PAGE, MAX_LIMIT, NEW_WINDOW_PROPS } from 'data/global';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { getMixpanelErrorProps } from 'axiosUtils';
import { ErrorViewedProps } from 'models/MixpanelEvents';

import './WithdrawnLeadsFileAccessSnapshot.styles.scss';

type WithdrawnLeadsFileAccessSnapshotProps = {
  className?: string;
  defaultOpen?: boolean;
};

const WithdrawnLeadsFileAccessSnapshot: React.FC<
  WithdrawnLeadsFileAccessSnapshotProps
> = (props) => {
  const { className, defaultOpen = true } = props;

  const [nodes, setNodes] = useState<DataRoomNode[]>([]);

  const { dealRoom } = useContext(DealContext);
  const { selectedLead } = useContext(LeadsContext);

  const { dataRoomId } = dealRoom || {};
  const { _id, withdrawnInterestDate, firstName } = selectedLead || {};

  const classes = classNames(
    'white-panel',
    'withdrawn-leads-file-access-snapshot',
    className,
  );

  const { t } = useTranslation();

  const getMixpanelProps = useGetMixpanelProps();

  const revokedDate = usePastTime()(withdrawnInterestDate);

  useEffect(() => {
    (async () => {
      try {
        const {
          data: { items },
        } = await api.portfolio.seller.getFilesSnapshot(_id, {
          $page: FIRST_PAGE,
          $limit: MAX_LIMIT,
        });

        setNodes(items);
      } catch (e) {
        mixpanelService.errorViewed(
          getMixpanelProps(getMixpanelErrorProps(e)) as ErrorViewedProps,
        );
      }
    })();
  }, [_id, getMixpanelProps]);

  return (
    <CollapsibleSection
      className={classes}
      defaultOpen={defaultOpen}
      trigger={
        <div className="withdrawn-leads-file-access-snapshot__heading">
          <DocumentsIcon />
          {t('dataRoom')}
        </div>
      }
    >
      <div className="withdrawn-info-container">
        <WarningExclamationIcon />
        <div>
          <p>{`${t('leadsAccessWasRevoked', {
            firstName,
          })} ${revokedDate}`}</p>
          <p>{t('leadsAccessWasRevokedDescription')}</p>
        </div>
      </div>

      <ListOfNodes nodes={nodes} />

      <Link
        to={getDataRoomRoute(dataRoomId)}
        {...NEW_WINDOW_PROPS}
        className="ncoded-button"
      >
        <LinkToIcon />
        {t('viewDataRoom')}
      </Link>
    </CollapsibleSection>
  );
};

export default WithdrawnLeadsFileAccessSnapshot;
